import React, { useState } from 'react';
import { Button, Form, message, Modal, Select } from 'antd';
import { useAddAspectGovernessAspectMutation } from '../../../../graphql/mutations.generated';
import { useTranslation } from '../../../../i18n/useTranslation';

type Props = {
    entityData: any;
    onClose: () => void;
    refetch?: () => void;
};

export const UpdateGovernanceStatusModal = ({ entityData, onClose, refetch }: Props) => {
    const { t } = useTranslation();
    const [updateAspectGovernance] = useAddAspectGovernessAspectMutation();
    const [isLoading, setIsLoading] = useState(false);

    const [form] = Form.useForm();

    const handleClose = () => {
        form.resetFields();
        onClose();
    };
    const handleOk = async (formData: any) => {
        setIsLoading(true);

        try {
            await updateAspectGovernance({
                variables: {
                    urn: entityData.urn,
                    input: {
                        status: formData.status,
                    },
                },
            });
            message.destroy();
            message.success({ content: t('Status Updated'), duration: 2 });
            setIsLoading(false);
        } catch (e: unknown) {
            message.destroy();
            setIsLoading(false);
        }
        refetch?.();
        handleClose();
    };

    return (
        <Modal
            className="f-modal"
            title={t('Update Governance Status')}
            visible
            onCancel={handleClose}
            keyboard
            centered
            footer={
                <>
                    <Button
                        form="updateGovernanceStatusForm"
                        key="submit"
                        htmlType="submit"
                        type="primary"
                        loading={isLoading}
                    >
                        {t('Update')}
                    </Button>
                    <Button onClick={handleClose} type="default">
                        {t('Cancel')}
                    </Button>
                </>
            }
        >
            <Form
                form={form}
                name="updateGovernanceStatusForm"
                onFinish={handleOk}
                layout="vertical"
                initialValues={{ status: entityData?.GovernanceStatusInfo?.status || 'None' }}
            >
                <Form.Item name="status" label={t('Select Status')}>
                    <Select
                        aria-label={t('Select Status')}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        options={[
                            { value: 'Under_Review', label: t('Under Review'), tabIndex: 0 },
                            { value: 'Certified', label: t('Certified'), tabIndex: 0 },
                            { value: 'Draft', label: t('Draft'), tabIndex: 0 },
                            { value: 'None', label: t('None'), tabIndex: 0 },
                        ]}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
